import type { CanvasNode, LayoutNodeType } from "@opus-dt/shared-types";
import type { validateCanvas } from "../canvas-validator";

export function defaultsForType(type: LayoutNodeType): Pick<CanvasNode, "label" | "data"> {
  switch (type) {
    case "MACHINE":
      return { label: "Máquina", data: {} };
    case "EQUIPMENT":
      return { label: "Equipamento", data: {} };
    case "SENSOR":
      return { label: "Sensor", data: {} };
    case "SCALE":
      return { label: "Balança", data: {} };
    case "CONTROL_POINT":
      return { label: "Controle", data: {} };
    case "INSPECTION":
      return { label: "Inspeção", data: {} };
    case "HUMAN_STEP":
      return { label: "Etapa humana", data: {} };
    case "GROUP":
      return { label: "Agrupamento", data: {} };
    case "START":
      return { label: "Início", data: {} };
    case "END":
      return { label: "Fim", data: {} };
    default:
      return { label: "Nó", data: {} };
  }
}

export function describeError(e: ReturnType<typeof validateCanvas>["errors"][number]): string {
  switch (e.kind) {
    case "MACHINE_MISSING_ID":
      return `Nó "${e.label}" é uma Máquina mas não está vinculada — escolha uma máquina no painel lateral.`;
    case "DUPLICATE_MACHINE":
      return `Duas representações para a mesma máquina (${e.machineId}). Remova ou re-vincule uma delas.`;
    case "EDGE_FROM_END":
      return `Existe uma conexão saindo de um nó "Fim" — remova-a.`;
    case "EDGE_TO_START":
      return `Existe uma conexão chegando a um nó "Início" — remova-a.`;
    case "DUPLICATE_EDGE":
      return `Conexão duplicada entre os mesmos nós.`;
    case "EDGE_DANGLING":
      return `Conexão referencia nó inexistente.`;
  }
}

export function describeWarning(w: ReturnType<typeof validateCanvas>["warnings"][number]): string {
  switch (w.kind) {
    case "CYCLE":
      return `Ciclo detectado no fluxo de produção (${w.nodes.length} nós).`;
    case "ORPHAN_NODE":
      return `Nó "${w.label}" não está conectado a nenhum outro.`;
  }
}
